import axios from 'axios'
import type { UpdateProfilePayload, UpdateProfileStepPayload } from '@/types/company'
import type { SuccessResponse } from '@/types/httpResponse'
import type { UserData } from '@/types/user'

const BASE_URL = '/dashboard/v1/chief/profile'

export const getProfileApiCall = async (abortController?: AbortController): Promise<UserData> => {
  const { data } = await axios.get(`${BASE_URL}/me`, {
    signal: abortController?.signal,
  })
  return data.data
}

export const updateProfileApiCall = async (abortController?: AbortController, params?: UpdateProfilePayload): Promise<UserData> => {
  const { data } = await axios.patch(`${BASE_URL}/company`, {
    ...params,
  }, {
    signal: abortController?.signal,
  })
  return data.data
}

export const updateProfileStepApiCall = async (abortController?: AbortController, params?: UpdateProfileStepPayload): Promise<SuccessResponse<UserData>> => {
  const { data } = await axios.put(`${BASE_URL}/step`, {
    ...params,
  }, {
    signal: abortController?.signal,
  })
  return data
}
